import { useState, useEffect } from "react";
import { fetchWithToken, hasPermission } from "@platform/core";
import { HEADERBFF_URL, ONE_ADMIN_URL } from "../../constants";

interface UserInfo {
  OrgCode: string;
}

const useOneAdmin = () => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [correlationId, setCorrelationId] = useState<string>("");

  useEffect(() => {
    hasPermission("OneAdmin.link").then((response) => setIsAdmin(response));
  }, []);

  async function linkToOneAdmin() {
    const response: Response = await fetchWithToken(`${HEADERBFF_URL}/v1/user`);
    setCorrelationId(response.headers.get("x-correlation-id") || "");
    if (!response.ok) {
      throw new Error(
        JSON.stringify({
          statusCode: response.status,
          statusText: response.statusText,
          body: await response.json(),
        })
      );
    }
    const user: UserInfo = await response.json();

    window.open(`${ONE_ADMIN_URL}${user.OrgCode}`, "_blank");
  }

  return { isAdmin, linkToOneAdmin, correlationId };
};

export default useOneAdmin;
